import React from "react";
import "./dropdowns.css";

const BaseDropdown = ({ defaultSelected, values, callback, className }) => {
  return (
    <select className={`base-dropdown ${className}`} onChange={callback}>
      {values.map((value, index) => (
        <option className="base-dropdown-value" key={index}>
          {value}
        </option>
      ))}
      <option className="base-dropdown-value" selected>
        {defaultSelected}
      </option>
    </select>
  );
};

export { BaseDropdown };
